// import { Datagrid, FunctionField, List, TextField } from "react-admin";

// export const LogsList = (props) => {
//   return (
//     <List {...props}>
//       <Datagrid >
//         <TextField source="id" />
//         <TextField source="user.name" />
//         <TextField source="action" />

//         <FunctionField
//           label="Created At"
//           render={(record) =>
//             `${new Date(record.created_at).toLocaleString()} `
//           }
//         />
//       </Datagrid>
//     </List>
//   );
// };
import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  FunctionField,
  useDataProvider,
  useNotify,
  Filter,
  TextInput,
  SelectInput,
  downloadCSV,
  DateInput,
} from 'react-admin';
import {
  Box,
  Card,
  CardContent,
  Chip,
  Divider,
  Grid,
  LinearProgress,
  Paper,
  Typography,
  Avatar,
  CircularProgress,
  Alert,
  ListItemText,
  Dialog, DialogTitle, DialogContent,
} from '@mui/material';
import {
  People as UsersIcon,
  ShoppingCart as OrdersIcon,
  Timeline as StatsIcon,
  Schedule as TimeIcon,
  CalendarToday as CalendarIcon,
  TrendingUp as TrendIcon,
} from '@mui/icons-material';
import { useEffect, useState } from 'react';
// import { unparse as convertToCSV } from 'papaparse';
import { SafePieChart } from './reports/OrdersReports';
import jsonExport from 'jsonexport/dist';


const ExportProgressDialog = ({ open, page, totalPages }) => {
  const progress = (page / totalPages) * 100;

  return (
    <Dialog open={open}>
      <DialogTitle>Export in Progress</DialogTitle>
      <DialogContent>
        <Typography>{`Exporting page ${page} / ${totalPages}`}</Typography>
        <LinearProgress variant="determinate" value={progress} />
      </DialogContent>
    </Dialog>
  );
};
const convertToCSV = (rows) => {
  if (!rows.length) return "";
  const header = Object.keys(rows[0]).join(",");
  const data = rows.map(r =>
    Object.values(r).map(v => `"${String(v).replace(/"/g, '""')}"`).join(",")
  );
  return [header, ...data].join("\n");
};

export const usePaginatedExporter = () => {
  const dataProvider = useDataProvider();
  const [progress, setProgress] = useState({ open: false, page: 0, totalPages: 0 });

  const exporter = async () => {
    const perPage = 500;

    // first call to get total
    const first = await dataProvider.getList("logs", {
      pagination: { page: 1, perPage },
      sort: { field: "id", order: "ASC" },
      filter: {},
    });

    let allRecords = [...first.data];
    const totalPages = Math.ceil(first.total / perPage);

    setProgress({ open: true, page: 1, totalPages });

    for (let page = 2; page <= totalPages; page++) {
      const { data } = await dataProvider.getList("logs", {
        pagination: { page, perPage },
        sort: { field: "id", order: "ASC" },
        filter: {},
      });
      allRecords = [...allRecords, ...data];
      setProgress({ open: true, page, totalPages }); // ✅ update instead of new snackbar
    }

    // build CSV
    const csvData = allRecords.map(record => ({
      ID: record.id,
      Name: record.user?.name ?? "",
      Gender: record.user?.gender ?? "",
      Phone:record.user?.phonenumber?`'${record.user?.phonenumber}`: "",
      Action: record.action,
      CreatedAt: new Date(record.created_at).toLocaleDateString(),
    }));

    const csv = convertToCSV(csvData);
      jsonExport(csvData, { rowDelimiter: ',' }, (err, csv) => {
        if (err) {
            console.error(err);
            return;
        }
        // Add UTF-8 BOM to fix Arabic characters in Excel
        const bom = '\uFEFF';
        downloadCSV(bom + csv, "activity_logs.csv");
    });

    setProgress({ open: false, page: 0, totalPages: 0 }); // close dialog
  };

  // return exporter + UI
  return {
    exporter,
    progressUI: (
      <ExportProgressDialog
        open={progress.open}
        page={progress.page}
        totalPages={progress.totalPages}
      />
    ),
  };
};
export const ActivityFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="search" alwaysOn />
    
    <SelectInput
      source="gender"
      choices={[
        { id: "male", name: "male" },
        { id: "female", name: "female" },
      ]}
      optionText="name"
      optionValue="id"
      allowEmpty
      alwaysOn
    />
    <SelectInput
      source="action"
      choices={[
        { id: "Crops Offer", name: "Crops Offer" },
        { id: "Crops Order", name: "Crops Order" },
        { id: "Crops Auction", name: "Crops Auction" },
        { id: "Services Offer", name: "Services Offer" },
        { id: "Services Order", name: "Services Order" },
        { id: "Inputs Offer", name: "Inputs Offer" },
        { id: "Inputs Order", name: "Inputs Order" },
        { id: "Mahsool Advisor", name: "Mahsool Advisor" },
        { id: "Product View", name: "Product View" },
        { id: "Product Order", name: "Product Order" },
        { id: "Invoice Sent", name: "Invoice Sent" },
        { id: "Invoice Accepted", name: "Invoice Accepted" },
        { id: "Invoice Rejected", name: "Invoice Rejected" },
        { id: "Donation Assigned", name: "Donation Assigned" },
        { id: "Donation Delivered", name: "Donation Delivered" },
        { id: "Negotiation Started", name: "Negotiation Started" },
        { id: "Negotiation Updated", name: "Negotiation Updated" },
        { id: "User Registered", name: "User Registered" },
        { id: "User Login", name: "User Login" },
        { id: "Admin Login", name: "Admin Login" },
        { id: "User Logout", name: "User Logout" },
        { id: "User Role Changed", name: "User Role Changed" },
        { id: "Admin Started Negotiation", name: "Admin Started Negotiation" },
        { id: "Admin Invoice Sent", name: "Admin Invoice Sent" },
        { id: "Admin Invoice Updated", name: "Admin Invoice Updated" },
        { id: "Admin Invoice Accepted", name: "Admin Invoice Accepted" },
        { id: "Admin Invoice Rejected", name: "Admin Invoice Rejected" }
      ]}
      optionText="name"
      optionValue="id"
      allowEmpty
      
    />
    <DateInput source="created_at_gte" label="Created After" />
    <DateInput source="created_at_lte" label="Created Before" />
  </Filter>
);
// SummaryCard Component
const SummaryCard = ({ title, value, icon: Icon, color = 'primary' }) => (
  <Card sx={{ boxShadow: 2 }}>
    <CardContent>
      <Box display="flex" alignItems="center" mb={1}>
        <Avatar sx={{ bgcolor: `${color}.main`, mr: 2, color: 'white' }}>
          <Icon />
        </Avatar>
        <Typography variant="body1" color="text.secondary">
          {title}
        </Typography>
      </Box>
      <Typography variant="h5" fontWeight="bold" color={`${color}.main`}>
        {value}
      </Typography>
    </CardContent>
  </Card>
);

// ActivityTypeList Component
const ActivityTypeList = ({ data }) => (
  <Card sx={{ height: '100%' }}>
    <CardContent>
      <Typography
        variant="h6"
        gutterBottom
        sx={{ display: 'flex', alignItems: 'center', fontWeight: 600 }}
      >
        <StatsIcon sx={{ mr: 1 }} /> Activity Types
      </Typography>
      <Divider sx={{ mb: 2 }} />
      {data?.length > 0 ? (
        data.map((item, index) => (
          <React.Fragment key={index}>
            <Box display="flex" justifyContent="space-between" alignItems="center" py={1}>
              <ListItemText primary={item.type} />
              <Chip label={item.count} color="primary" size="small" />
            </Box>
            {index < data.length - 1 && <Divider />}
          </React.Fragment>
        ))
      ) : (
        <Typography variant="body2" color="text.secondary" align="center" mt={2}>
          No activity types found
        </Typography>
      )}
    </CardContent>
  </Card>
);

// DailyActivityProgress Component
const DailyActivityProgress = ({ data }) => {
  const maxCount = Math.max(...(data?.map((item) => item.count) || [0]));

  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Typography
          variant="h6"
          gutterBottom
          sx={{ display: 'flex', alignItems: 'center', fontWeight: 600 }}
        >
          <CalendarIcon sx={{ mr: 1 }} /> Daily Activity
        </Typography>
        <Divider sx={{ mb: 2 }} />
        {data?.length > 0 ? (
          data.map((item, index) => (
            <Box key={index} mb={2}>
              <Box display="flex" justifyContent="space-between" mb={0.5}>
                <Typography variant="body2">{new Date(item.date).toLocaleDateString()}</Typography>
                <Typography variant="body2" fontWeight="bold">
                  {item.count}
                </Typography>
              </Box>
              <LinearProgress
                variant="determinate"
                value={(item.count / maxCount) * 100}
                color="primary"
                sx={{
                  height: 8,
                  borderRadius: 4,
                  backgroundColor: (theme) =>
                    `${theme.palette.grey[300]} !important`,
                  '& .MuiLinearProgress-bar': {
                    backgroundColor: '#1976d2',
                  },
                }}
              />
            </Box>
          ))
        ) : (
          <Typography variant="body2" color="text.secondary" align="center" mt={2}>
            No daily activity data
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export const LogsList = (props) => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const [summaryData, setSummaryData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { exporter, progressUI } = usePaginatedExporter();

  useEffect(() => {
    const fetchSummaryData = async () => {
      try {
        const token = JSON.parse(localStorage.getItem('token'));
        const response = await fetch(`${process.env.REACT_APP_URL}/admin/logs/summary`, {
          method: 'GET',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

        const data = await response.json();
        setSummaryData(data);
      } catch (err) {
        console.error('Error fetching summary data:', err);
        setError(err.message);
        notify('Error loading activity summary', { type: 'error' });
      } finally {
        setLoading(false);
      }
    };

    fetchSummaryData();
  }, []);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ my: 3 }}>
        Failed to load activity summary. Please try again later.
      </Alert>
    );
  }

  if (!summaryData) {
    return (
      <Alert severity="warning" sx={{ my: 3 }}>
        No activity summary data available.
      </Alert>
    );
  }

  return (
    <>
      {/* Summary Section */}
      <Box mb={4}>
        <Typography
          variant="h5"
          gutterBottom
          sx={{ display: 'flex', alignItems: 'center', fontWeight: 600 }}
        >
          <TrendIcon color="primary" sx={{ mr: 1 }} /> Activity Summary
        </Typography>

        <Grid container spacing={3} mb={4}>
          <Grid item xs={12} md={4}>
            <SummaryCard
              title="Total Activities"
              value={summaryData.totalActivities}
              icon={StatsIcon}
              color="primary"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <SummaryCard
              title="Top Activity"
              value={summaryData.activitiesByType[0]?.type || 'N/A'}
              icon={OrdersIcon}
              color="secondary"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <SummaryCard
              title="Peak Hour"
              value={
                summaryData.peakActivityTimes[0]
                  ? `${summaryData.peakActivityTimes[0].hour}:00`
                  : 'N/A'
              }
              icon={TimeIcon}
              color="success"
            />
          </Grid>
        </Grid>
       
        <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
        <SafePieChart
                          data={summaryData.activitiesByType} 
                          title="Activity Types"
                        />
          </Grid>
          <Grid item xs={12} md={6}>
            <ActivityTypeList data={summaryData.activitiesByType} />
          </Grid>
          <Grid item xs={12} md={6}>
            <DailyActivityProgress data={summaryData.dailyActivityCount} />
          </Grid>
        </Grid>
      </Box>

      {/* Logs List */}
      <Paper elevation={0} sx={{ p: 2, mt: 4 }}>
        <Typography
          variant="h5"
          gutterBottom
          sx={{ display: 'flex', alignItems: 'center', fontWeight: 600 }}
        >
          <UsersIcon color="primary" sx={{ mr: 1 }} /> Activity Logs
        </Typography>
        <List {...props} hasCreate={false}  filters={ActivityFilter()} exporter={exporter}>
        {progressUI}
          <Datagrid bulkActionButtons={false}>
            <TextField source="id" />
            <TextField source="user.name" label="User" />
            <TextField source="action" label="Action" />
            <FunctionField
              label="Created At"
              render={(record) => new Date(record.created_at).toLocaleString()}
            />
          </Datagrid>
        </List>
      </Paper>
    </>
  );
};